var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtTrainingLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#CURVA_H);\n      }\n\n      .cls-2 {\n        fill: url(#PALITO_H-3);\n      }\n\n      .cls-3 {\n        fill: url(#PALITO_H-4);\n      }\n\n      .cls-4 {\n        fill: url(#PALITO_H-5);\n      }\n\n      .cls-5 {\n        fill: url(#PALITO_H-2);\n      }\n\n      .cls-6 {\n        fill: url(#PALITO_H);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PALITO_H",
    "data-name": "PALITO H",
    x1: 117.14,
    y1: 461.57,
    x2: 117.14,
    y2: 241.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#860804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#860804",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#860804",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#860804",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860804",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PALITO_H-2",
    "data-name": "PALITO H",
    x1: 463.93,
    y1: 621.7,
    x2: 463.93,
    y2: 839.45,
    xlinkHref: "#PALITO_H"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "CURVA_H",
    "data-name": "CURVA H",
    x1: 290.54,
    y1: 839.45,
    x2: 290.54,
    y2: 241.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#860804",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#860804",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#860804",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#860804",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#860804",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#860804",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#860804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#860804",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#860804",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#860804",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#860804",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860804",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PALITO_H-3",
    "data-name": "PALITO H",
    x1: 811.04,
    y1: 240.22,
    x2: 811.04,
    y2: 839.78,
    xlinkHref: "#PALITO_H"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PALITO_H-4",
    "data-name": "PALITO H",
    x1: 659.23,
    y1: 460.48,
    x2: 659.23,
    y2: 240.54,
    xlinkHref: "#PALITO_H"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PALITO_H-5",
    "data-name": "PALITO H",
    x1: 962.86,
    x2: 962.86,
    xlinkHref: "#PALITO_H"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m153.43,241.63h-72.58s0,191.39,0,191.39c0,15.77,12.78,28.55,28.55,28.55h15.61c15.69,0,28.42-12.72,28.42-28.42v-191.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m471.67,621.7h-15.01c-16.02,0-29.01,12.99-29.01,29.01v188.74h72.58v-189.2c0-15.77-12.78-28.55-28.55-28.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m427.64,241.63v135.15c0,12.41-1.8,24.76-5.52,36.59-10.88,34.62-42.41,92.57-131.59,92.57v.04c-209.68,0-209.68,185.1-209.68,187v146.48h72.58v-131.24c0-23.57,5.65-46.88,16.99-67.54,17.28-31.49,51.76-65.53,120.11-65.53v-.04c209.68,0,209.68-187,209.68-187v-146.48h-72.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m801.07,240.22c-15.77,0-28.55,12.78-28.55,28.55v571h77.05V268.78c0-15.77-12.78-28.55-28.55-28.55h-19.95Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m695.52,240.54h-72.58s0,191.39,0,191.39c0,15.77,12.78,28.55,28.55,28.55h15.61c15.69,0,28.42-12.72,28.42-28.42v-191.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m999.15,241.63h-72.58s0,191.39,0,191.39c0,15.77,12.78,28.55,28.55,28.55h15.61c15.69,0,28.42-12.72,28.42-28.42v-191.52Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtTrainingLogo);
export default __webpack_public_path__ + "static/media/HT_TRAINING_logo.313a138244083e2057a28c04c3f2598d.svg";
export { ForwardRef as ReactComponent };